import { useStore } from "../index";

export const usePermission = () => useStore(({ permission }) => permission);
